//@vendor
const Immutable = require('immutable');
const get = require('lodash/object/get');
//@utilities
const LoanSettlementsDetailReducer = require('../reducers/loans/loanSettlementsDetails');
const { hash } = require('utilities/hash');
// @ constants
const actionTypes = require('../loansConstants/actionTypes');
const { DATE_FILTER_NONE, EURO_TEXT } = require('constants/index');

const filtersInitialState = Immutable.fromJS({
    isActive: false,
    date: {
        from: '',
        to: '',
        selected: DATE_FILTER_NONE
    }
});

const initialState = Immutable.fromJS({
    isFetching: false,
    isFetchingNextPage: false,
    error: false,
    success: false,
    nextPage: '',
    byId: {},
    byOrder: [],
    filters: filtersInitialState
});

function mapPaginationData(paginationData) {
    return {
        paginationIndicator: paginationData.indPaginacion,
        moreDataIndicator: paginationData.indMasDatos,
        productContract: paginationData.productoContrato,
        numeroContrato: paginationData.numeroContrato,
        liquidationPeriodEndDate: paginationData.fechaFinPeriodoLiq,
        contractTableIndicator: paginationData.indtablaContratos
    };
}

function parseSettlement(settlement, loanId, loanSettlementId) {
    const showDebit = settlement.signoImporteLiquidoINLIQUID === 'D';
    const defaultBalance = {
        amount: get(settlement, 'importe.importe', 0) || 0,
        currency: get(settlement, 'importe.divisa', EURO_TEXT) || EURO_TEXT
    };
    let creditAmount;
    let debitAmount;

    const amount = { amount: 0, currency: defaultBalance.currency };
    if (showDebit) {
        debitAmount = defaultBalance;
        creditAmount = amount
    } else {
        debitAmount = amount
        creditAmount = defaultBalance;
    }

    return Immutable.fromJS({
        amount,
        loanId,
        loanSettlementId,
        aplicadaCODAPLI: settlement.aplicadaCODAPLI,
        transactionApplicationCode: settlement.codigoTipoAplicacionCOTAPLRE,
        fromDate: settlement.fechaDesdeFECOMPEL,
        toDate: settlement.fechaHastaFEFINPEL,
        processDate: settlement.fechaProcesoFECHAPRO,
        creditAmount,
        debitAmount,
        indicator: settlement.indicador,
        currency: settlement.monedaMONEDA || EURO_TEXT,
        transactionOrigin: settlement.origenOperacionDESORIGE,
        liquidAmountSign: settlement.signoImporteLiquidoINLIQUID,
        taedebeTASAFRAN: settlement.taedebeTASAFRAN,
        taeexcesoTASA9: settlement.taeexcesoTASA9,
        taehaberTASA7: settlement.taehaberTASA7,
        details: LoanSettlementsDetailReducer(undefined, { type: null })
    });
}

function parseNextPage(settlements, state, loanId, nextPage) {
    let byId = state.get('byId');
    let byOrder = state.get('byOrder');

    settlements.forEach(settlement => {
        const loanSettlementId = hash([settlement.fechaDesdeFECOMPEL, settlement.fechaHastaFEFINPEL, settlement.importe.importe]);

        byOrder = byOrder.push(loanSettlementId);
        byId = byId.set(loanSettlementId, parseSettlement(settlement, loanId, loanSettlementId));
    });

    return state.mergeDeep({
        byId,
        byOrder,
        nextPage,
        isFetchingNextPage: false,
        error: false
    });
}

function mapSettlements(state, settlements, loanId, paginationData, nextPage) {
    const byId = {};
    const byOrder = [];

    settlements.forEach(settlement => {
        const loanSettlementId = hash([settlement.fechaDesdeFECOMPEL, settlement.fechaHastaFEFINPEL, settlement.importe.importe]);

        byOrder.push(loanSettlementId);
        byId[loanSettlementId] = parseSettlement(settlement, loanId, loanSettlementId);
    });

    return state.mergeDeep({
        isFetching: false,
        error: false,
        success: true,
        byId,
        byOrder,
        paginationData: mapPaginationData(paginationData),
        nextPage
    });
}

function LoanSettlementsReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.FETCH_LOAN_SETTLEMENTS:
            return state.merge({
                isFetching: true,
                error: false,
                success: false
            });
        case actionTypes.FETCH_LOAN_SETTLEMENTS_SUCCESS:
            return mapSettlements(state, action.payload.settlements, action.payload.loanId, action.payload.paginationData, action.payload.nextPage);
        case actionTypes.FETCH_LOAN_SETTLEMENTS_FAILURE:
            return state.merge({
                isFetching: false,
                error: action.payload.error,
                success: false
            });
        case actionTypes.FETCH_LOAN_SETTLEMENTS_DETAILS:
        case actionTypes.FETCH_LOAN_SETTLEMENTS_DETAILS_SUCCESS:
        case actionTypes.FETCH_LOAN_SETTLEMENTS_DETAILS_FAILURE:
            return state.mergeDeepIn(['byId', action.payload.loanSettlementId, 'details'], LoanSettlementsDetailReducer(state.getIn(['byId', action.payload.loanSettlementId, 'details']), action));
        case actionTypes.LOAN_SETTLEMENTS_SET_FILTERS:
            return state.mergeDeepIn(['filters'], action.payload.filters).setIn(['byId'], Immutable.Map()).setIn(['byOrder'], Immutable.List());
        case actionTypes.CLEAR_LOAN_SETTLEMENTS_FILTERS:
            return state.mergeDeepIn(['filters'], filtersInitialState).setIn(['byId'], Immutable.Map()).setIn(['byOrder'], Immutable.List());
        case actionTypes.LOAN_SETTLEMENTS_FETCH_NEXT_PAGE:
            return state.set('isFetchingNextPage', true);
        case actionTypes.LOAN_SETTLEMENTS_FETCH_NEXT_PAGE_SUCCESS:
            return parseNextPage(action.payload.settlements, state, action.payload.loanId, action.payload.nextPage);
        case actionTypes.LOAN_SETTLEMENTS_FETCH_NEXT_PAGE_FAILURE:
            return state.set('error', action.payload.error);
        default:
            return state;
    }
}

module.exports = LoanSettlementsReducer;
